import { tMsg } from '@/features/locale/translate'

import { isWalletUserRejection } from './isWalletUserRejection'
import { mapWalletWriteError } from './submitContractWrite'
import { markWalletReconnectCooldown } from './walletReconnectCooldown'
import { clearWalletSigningLock, markWalletSigningLock } from './walletSigningLock'

export type WalletWriteProgressPhase = 'wallet' | 'submitted'

export function beginWalletSigning(): void {
  markWalletSigningLock()
  markWalletReconnectCooldown()
}

export function endWalletSigning(): void {
  clearWalletSigningLock()
}

export function toWalletUserFacingError(error: unknown): string {
  if (isWalletUserRejection(error)) {
    return tMsg().wallet.error.userRejected
  }
  if (error instanceof Error && error.message) {
    return error.message
  }
  return mapWalletWriteError(error).message
}

export function isWalletUserCancellationMessage(message: string | undefined): boolean {
  if (!message) return false
  return message === tMsg().wallet.error.userRejected
}
